import { editDeviceCalibrateResultRequest, getDeviceCalibrateResultRequest } from "@/service/parameterConfiguration";
import { Button, Divider, Form, Input, InputNumber, message } from "antd";
import { useEffect, useState } from "react";

interface iProps {
    id: number | string,
    sn: number | string,
    refreshTrigger?: number,
    onRefreshAll?: () => void
}

const LaserRadarBsdForm = (props: iProps) => {

    const { id, sn, refreshTrigger, onRefreshAll } = props

    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [hasSearch, setHasSearch] = useState(false);


    const updateForm = async () => {
        let _formValue = {};
        try {
            setIsLoading(true);
            const res = await getDeviceCalibrateResultRequest({ id, sn });
            const data = res.data?.data || {};

            const parseNumber = (v: any) => (v === null || v === undefined || v === '' ? undefined : Number(v));

            _formValue = {
                version: data.version,
                success: parseNumber(data.success),
                bodyLength: parseNumber(data.bodyLength),
                bodyWidth: parseNumber(data.bodyWidth),
                rearOverhangLength: parseNumber(data.rearOverhangLength),
                bodyOuterToFrontWheelOuterDist: parseNumber(data.bodyOuterToFrontWheelOuterDist),
                frontOverhangLength: parseNumber(data.frontOverhangLength),
                frontWheelOuterDist: parseNumber(data.frontWheelOuterDist),
                targetCenterToFrontWheelOuterDist: parseNumber(data.targetCenterToFrontWheelOuterDist),
                targetCenterToFrontAxleHorizontalDist: parseNumber(data.targetCenterToFrontAxleHorizontalDist),
                targetHeight: parseNumber(data.targetHeight),
                radarCenterToFrontAxleDist: parseNumber(data.radarCenterToFrontAxleDist),
                radarMountingHeight: parseNumber(data.radarMountingHeight),
                radarBracketExtensionLength: parseNumber(data.radarBracketExtensionLength),
                calibrationOffsetX: parseNumber(data.calibrationOffsetX),
                calibrationOffsetY: parseNumber(data.calibrationOffsetY),
                calibrationOffsetZ: parseNumber(data.calibrationOffsetZ),
                rotationMatrix11: parseNumber(data.rotationMatrix11),
                rotationMatrix12: parseNumber(data.rotationMatrix12),
                rotationMatrix13: parseNumber(data.rotationMatrix13),
                rotationMatrix21: parseNumber(data.rotationMatrix21),
                rotationMatrix22: parseNumber(data.rotationMatrix22),
                rotationMatrix23: parseNumber(data.rotationMatrix23),
                rotationMatrix31: parseNumber(data.rotationMatrix31),
                rotationMatrix32: parseNumber(data.rotationMatrix32),
                rotationMatrix33: parseNumber(data.rotationMatrix33),
                reprojectionError: parseNumber(data.reprojectionError),
                calibrationTime: parseNumber(data.calibrationTime),
                dataValidity: parseNumber(data.dataValidity),
            };
            setHasSearch(true);
        } catch (err) {
            console.error("err", err);
        } finally {
            setIsLoading(false);
            form.setFieldsValue(_formValue);
        }

    }
    useEffect(() => {
        updateForm();
    }, [id, sn, refreshTrigger]);


    const submitForm = async () => {
        try {
            setIsLoading(true);
            const values = await form.validateFields();
            const params = {
                id,
                ...values
            }
            const res = await editDeviceCalibrateResultRequest(params, sn);

            if (res.data.code === 0) {
                message.success('下发BSD激光雷达标定结果成功');
                onRefreshAll?.();
            } else {
                message.error('下发BSD激光雷达标定结果失败');
            }
        } catch (error) {
            console.error("submit failed:", error);
            message.error('下发BSD激光雷达标定结果失败');
        } finally {
            setIsLoading(false);
        }
    }

    return <div>
        <Divider>BSD激光雷达标定结果</Divider>
        <Form disabled form={form} labelAlign="left" labelCol={{ span: 10, style: { whiteSpace: 'normal', overflowWrap: 'break-word' } }} wrapperCol={{ span: 12 }}>
            <Form.Item label="参数版本号" name="version" style={{ marginBottom: '12px' }}>
                <Input disabled={true} />
            </Form.Item>
            <Form.Item label="标定状态" name="success" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="车身长度" name="bodyLength" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="车身宽度" name="bodyWidth" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="后悬距离" name="rearOverhangLength" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="车身外侧到前轮外延距离" name="bodyOuterToFrontWheelOuterDist" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="前悬距离" name="frontOverhangLength" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="前轮外沿距离" name="frontWheelOuterDist" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="靶标中心点到前轮外延距离" name="targetCenterToFrontWheelOuterDist" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="靶标中心到前轮轴水平距离" name="targetCenterToFrontAxleHorizontalDist" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标靶高度" name="targetHeight" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="雷达中心到前轮轴距离" name="radarCenterToFrontAxleDist" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="雷达安装高度" name="radarMountingHeight" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="雷达安装支架延申长度" name="radarBracketExtensionLength" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="被标定物偏移量: Dx" name="calibrationOffsetX" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="被标定物偏移量: Dy" name="calibrationOffsetY" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="被标定物偏移量: Dz" name="calibrationOffsetZ" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R11" name="rotationMatrix11" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R12" name="rotationMatrix12" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R13" name="rotationMatrix13" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R21" name="rotationMatrix21" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R22" name="rotationMatrix22" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R23" name="rotationMatrix23" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R31" name="rotationMatrix31" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R32" name="rotationMatrix32" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="旋转矩阵 R33" name="rotationMatrix33" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定重投影误差 (pixel)" name="reprojectionError" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="标定时间" name="calibrationTime" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="数据有效性" name="dataValidity" style={{ marginBottom: '12px' }}>
                <InputNumber style={{ width: '100%' }} />
            </Form.Item>
            <div style={{ textAlign: 'right', display: 'none' }}>
                <Button
                    type="primary"
                    disabled={!hasSearch}
                    loading={isLoading}
                    onClick={submitForm}
                >
                    下发BSD激光雷达标定结果
                </Button>
            </div>
        </Form>
    </div>
};

export default LaserRadarBsdForm;
